"use client";
import { Pagination } from "@/components/pagination/Pagination";
import type { SearchData } from "front-search-schema/algolia";
import { useRouter } from "next/navigation";
import type { ReactNode } from "react";
import { setConfigValue, updateUrl } from "../_utils/searchStore";

type Props = {
  children: ReactNode;
  data: SearchData;
  page: number;
};
export const TravelListContainer = ({ children, data, page }: Props) => {
  const router = useRouter();

  const handleClick = (_: React.ChangeEvent<unknown>, value: number) => {
    setConfigValue({
      type: "page",
      value: value.toString(),
    });

    updateUrl(router);
    window.scrollTo(0, 0);
  };

  return (
    <div className="grid gap-4 py-4 content-start grid-cols-1 min-w-0 p-2 xxl:col-span-2 max-w-[1000px] mx-auto">
      {page > 1 && (
        <Pagination total={data.totalTravels} page={page} onClick={handleClick} nbPerPage={20} hidePageLink />
      )}
      {children}
      {data.totalTravels > 0 && (
        <Pagination total={data.totalTravels} page={page} onClick={handleClick} nbPerPage={20} />
      )}
    </div>
  );
};
